import { createFileRoute } from '@tanstack/react-router'

import { ShipmentEditPage } from '#/modules/shipments/edit/shipment-edit-page'

export const Route = createFileRoute('/_shell/shipments_/$shipmentId/edit')({
  component: function ShipmentEditRoute() {
    const { shipmentId } = Route.useParams()
    return <ShipmentEditPage shipmentId={shipmentId} />
  },
})
